export const publicRoutes = [
  'login',
  'organization-selection',
  'identity-info',
  'otp-verification',
  'lockdown',
];
